export default __webpack_public_path__ + "static/balthazaurus-d85103c83ec16077a1133cd696be0436.jpg";